import {useContext, useMemo} from "react";

import {ReservationService} from "../../../services";
import {HTTPContext} from "../../contexts";

export const useReservationService = () => {
    const http = useContext(HTTPContext);
    return useMemo(() => new ReservationService(http), [http]);
};
